module.exports = __webpack_public_path__ + "img/og-whatsapp.c749aff0.svg";